import { API_PATH } from '../../config/config';

export default class BoxGenerator {
	static openingTag() {
		return '<section class="gr-cols-3 gr-responsive">';
	}

	static closingTag() {
		return '</section>';
	}

	static generateBox(article) {
		if (!article) return;
		return `
			<div class="grid-card">
				<a href="${API_PATH}/console/doc/v1/article-view?id=${article.id}" class="grid-card__link">
					<span class="grid-card__header">${article.title}</span>
					<span class="grid-card__content">${article.description}</span>
				</a>
			</div>
		`
	}

	static getContent(description) {
		if (!description) return;

		return this.truncText(description, 150);
	}

	static truncText(text, length) {
		if (!text) return "";
		let trim;
		if (text.length > length) {
			trim = text.substr(0, length);
			trim = trim.substr(
				0,
				Math.min(trim.length, trim.lastIndexOf(" "))
			);
			trim = trim + "...";
		} else {
			trim = text;
		}
		return trim;
	}
}